import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import HomePage from "./pages/Home";
import LoginPage from "./pages/Login";
import SignupPage from "./pages/Signup";
import PricingPage from "./pages/Pricing";
import ReviewsPage from "./pages/Reviews";
import BlogPage from "./pages/Blog";
import NewArticlePage from "./pages/New-Article";
import ArticlePage from "./pages/Article";
import EditProfilePage from "./pages/EditProfile";
import ChatPage from "./pages/Chat";
import RequestPage from "./pages/NewRequest";
import LiveChatsPage from "./pages/admin/LiveChats";
import RequestsPage from "./pages/admin/Requests";
import AdminPage from "./pages/Admin";
import ProfilePage from "./pages/Profile";
import SupportPage from "./pages/Support";
import AdminChatPage from "./pages/admin/AdminChat";
import SupportUsPage from "./pages/SupportUs";
import DonatePage from "./pages/Donate";
import DonateRequestPage from "./pages/DonateRequest";

import "./assets/style/master.css";
import DonationsPage from "./pages/admin/Donations";

const App = () => (
	<BrowserRouter>	
		<Switch>
			<Route exact path="/" component={HomePage} />
			<Route exact path="/auth/login" component={LoginPage} />
			<Route exact path="/auth/signup" component={SignupPage} />
			<Route exact path="/pricing" component={PricingPage} />
			<Route exact path="/reviews" component={ReviewsPage} />
			<Route exact path="/blog" component={BlogPage} />
			<Route exact path="/blog/article/" component={() => (<Redirect to="/blog" />)} />
			<Route exact path="/blog/new" component={NewArticlePage} />
			<Route path="/blog/article/:id" component={ArticlePage} />
			<Route path="/profile/:id" component={ProfilePage} />
			<Route exact path="/profile" component={ProfilePage} />
			<Route exact path="/edit-profile" component={EditProfilePage} />
			<Route exact path="/new-request" component={RequestPage} />
			<Route exact path="/admin" component={AdminPage} />
			<Route exact path="/admin/requests" component={RequestsPage} />
			<Route exact path="/admin/chats" component={LiveChatsPage} />
			<Route exact path="/admin/donations" component={DonationsPage} />
			<Route exact path="/admin/chats/:id" component={AdminChatPage} />
			<Route exact path="/support" component={SupportPage} />
			<Route exact path="/support/chat" component={ChatPage} />
			<Route exact path="/support-us" component={SupportUsPage} />
			<Route exact path="/donate-a-program" component={DonatePage} />
			<Route exact path="/donate-a-program/request" component={DonateRequestPage} />
		</Switch>
	</BrowserRouter>
);

export default App;